import angular from 'angular';
import uiRouter from 'angular-ui-router';
import Auth from './auth/auth';
import Bookings from './bookings/bookings';
import OnTheBeach from './onTheBeach/onTheBeach';
import myBookingApi from '../api/mybooking/mybooking';
import languageService from '../services/language.service';
import cacheService from '../services/cache.service';
import referenceFormatter from '../common/filters/referenceFormatter';

const routesModule = angular.module('app.routes', [
    uiRouter,
    myBookingApi,
    languageService,
    cacheService,
    referenceFormatter,
    Auth,
    Bookings,
    OnTheBeach
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";
        //HOTFIX  MYB-123 TODO: improve lang url
        $urlRouterProvider.when('/my-booking/goldupgrade?booking&email&confirm', '/en/my-booking/goldupgrade?booking&email&confirm');
        $stateProvider
            .state('old_goldupgrade', {
                resolve: {
                    data: function ($state, $stateParams, $q, languageService, authService, myBookingService, cacheService, ReferenceFormatterFilter) {
                        'ngInject';
                        let reference = ReferenceFormatterFilter($stateParams.booking);
                        authService.logout();
                        authService.loginByBookingReferenceAndCustomerEmail(reference, $stateParams.email)
                            .then((response) => {
                                //Bookings
                                return myBookingService.getGlobalInfoBooking(reference);
                            })
                            .then((response) => {
                                cacheService.set('bookingReference', response.booking.reference);
                                languageService.setLanguage($stateParams.locale || null);
                                $state.go('bookings.booking.goldupgrade', {
                                    bookingReference: response.booking.reference
                                });
                            })
                            .catch(error => {
                                authService.logout();
                            });
                    }
                },
                url: '/{locale}/my-booking/goldupgrade?booking&email&confirm'
            });
        $urlRouterProvider.when('/my-booking?tab&booking&email&confirm', '/en/my-booking?tab&booking&email&confirm');
        $stateProvider
            .state('tab_name', {
                resolve: {
                    data: function ($state, $stateParams, $q, languageService, authService, myBookingService, cacheService, ReferenceFormatterFilter) {
                        'ngInject';
                        let reference = ReferenceFormatterFilter($stateParams.booking);
                        authService.loginByBookingReferenceAndCustomerEmail(reference, $stateParams.email)
                            .then((response) => {
                                //Bookings
                                return myBookingService.getGlobalInfoBooking(reference);
                            })
                            .then((response) => {
                                cacheService.set('bookingReference', response.booking.reference);
                                languageService.setLanguage($stateParams.locale || null);
                                if($state.href('bookings.booking.' + $stateParams.tab) !== null){
                                    $state.go('bookings.booking.' + $stateParams.tab, {
                                        locale: $stateParams.locale,
                                        bookingReference: response.booking.reference
                                    });
                                }else{
                                    authService.logout();
                                    $stateParams.email = "";
                                    cacheService.set('bookingReference', "");
                                    $state.go('auth.login');
                                }

                            })
                            .catch(error => {
                                authService.logout();
                            });
                    }
                },
                url: '/{locale}/my-booking?tab&booking&email&confirm'
            });
    })
    .name;

export default routesModule;


// WEBPACK FOOTER //
// ./client/app/routes/routes.js